module.exports = {
  title: 'Popup Handler with Gesture Handler and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-07-26',
  slug: 'popup-handler',
  tags: ['skia', 'gesture-handler'],
};
